import React, { useContext } from "react";
import styles from "./QuoteExpanded.module.css";
import { ChevronRight } from "react-feather";
import Image from "../UI/Image";
import AppContext from "../../store/app-context";
import AuthContext from "../../store/auth-context";
import parse from "html-react-parser";

const QuoteExpanded = ({ quote, background, onViewDetails, quoteDetail}) => {
  const appCtx = useContext(AppContext);
  const authCtx = useContext(AuthContext);

  let label_qty = 'Quantity';
  let label_instrument = 'Instrument:';
  let label_login = 'Login';
  let label_inquire = 'Inquire';
  let label_each = 'each';
  let label_items =  'Items';
  let label_price = 'List price';
  let viewDetails = 'View full quote details';

  if (appCtx?.bioradResources) {
    label_qty = appCtx?.bioradResources?.Quantity ?? 'Quantity';
    label_instrument = appCtx?.bioradResources?.Instrument ?? 'Instrument:';
    label_login = appCtx.bioradResources.Login ? appCtx.bioradResources.Login : 'Login';
    label_inquire = appCtx.bioradResources.Inquire_Price ? appCtx.bioradResources.Inquire_Price : 'Inquire';
    label_each = appCtx.bioradResources.Label_Unit_Measure_Value ? appCtx.bioradResources.Label_Unit_Measure_Value : 'each';
    label_items = appCtx.bioradResources.Cart_Items_Header ? appCtx.bioradResources.Cart_Items_Header : 'Items';
    label_price = appCtx.bioradResources.List_Price ? appCtx.bioradResources.List_Price : 'List price';
    viewDetails = appCtx.bioradResources.ViewDetails ? appCtx.bioradResources.ViewDetails : 'View full quote details';
  }
  
  const isFirstWhite = background === "background1";

  const getRowClass = (index) => {
    const isEven = index % 2 === 0;
    return isFirstWhite ?
    isEven ? styles.rowWhite : styles.rowGray
    : isEven ? styles.rowGray : styles.rowWhite;
  };

  if (quote.isQuotedPrice) {
    label_price = appCtx && appCtx.bioradResources && appCtx.bioradResources.Quoted_Price ? appCtx.bioradResources.Quoted_Price : 'Quoted price';
  } else if (quote.isAccountPrice) {
    label_price = appCtx && appCtx.bioradResources && appCtx.bioradResources.Account_Price ? appCtx.bioradResources.Account_Price : 'Your price';
  }

  const webRef = quote.webReference
      ? "/" + quote.webReference
      : "";

  const loginUrl =
    appCtx.envProp.loginUrl +
    appCtx.envProp.appServer +
    appCtx.envProp.appName +
    webRef +
    "&ui_locales=" +
    appCtx.lang;

  return (
    <div className={quoteDetail ? styles.detailsContainer : styles.itemsContainer}>
      {quoteDetail && (
        <div className={styles.listheaders}>
        <div className={styles.listheaders__items}>
          <span className={styles.name}>
            {label_items}
          </span>
          <span className={styles.price}>
            {label_price}
          </span>
        </div>
      </div>
      )}
      {quote?.quoteLineEntityList.map((item, index) => {
        let imageSrc = item.skuImageUrl;
        if (imageSrc && !imageSrc.includes('www') && !imageSrc.includes('http')) {
          imageSrc = appCtx.envProp.webServer + imageSrc;
        }

        let skuURL = null;
        if (item.skuUrl && item.skuUrl !== '') {
          if (item.skuUrl.includes('www') || item.skuUrl.includes('http')) {
            skuURL = item.skuUrl;
          } else if (item.skuType === 'Bioplex') {
            skuURL = appCtx.envProp.appServer + item.skuUrl;
          } else {
            skuURL = `${appCtx.envProp.webServer}${appCtx.lang.toLowerCase()}-${appCtx.country.toLowerCase()}/sku/${item.skuUrl}?ID=${item.skuNumber}`;
          }
        }

        return (
          <div key={index} className={`${styles.itemRow} ${getRowClass(index)}`}>
            <div className={styles.itemImage}>
              <Image imageSrc={imageSrc} />
            </div>
            <div className={styles.itemDetails}>
              <p className={styles.itemName}>
                {skuURL
                  ? <a href={skuURL}>{item.skuTitle ? parse(item.skuTitle) : ''} #{item.skuNumber}</a>
                  : <span>{item.skuTitle ? parse(item.skuTitle) : ''} #{item.skuNumber}</span>}
              </p>
              <p className={styles.itemDesc}>{item.skuDescription ? parse(item.skuDescription?.replace(/\n$/, '').replace(/\n/g, '<br/>')) : ''}</p>
              <p className={styles.itemQty}>
                <strong>{label_qty}:</strong> {item.quantity}
              </p>
              {item.instrument && (
                <div>{label_instrument}: {item.instrument}</div>
              )}
            </div>
            {quoteDetail && (
              <div>
                {item.formattedExtendedPrice && item.formattedExtendedPrice !== 'Inquire' && (
                  <div className={styles.price}>{item.formattedExtendedPrice}</div>
                )}
                {item.formattedExtendedPrice && item.formattedExtendedPrice === 'Inquire' && (
                  <div className={styles.price}><span>{label_inquire}</span></div>
                )}
                {item.formattedUnitPrice && item.formattedUnitPrice !== 'Inquire' && item.formattedUnitPrice !== 'Login' && (
                  <div className={styles.eachPrice}>
                    {item.formattedUnitPrice}&nbsp;{item.quantity && item.quantity > 1 && <span>{label_each}</span>}
                  </div>
                )}
                {item.formattedUnitPrice && item.formattedUnitPrice === 'Inquire' && (
                  <div className={styles.eachPrice}>
                    <span>{label_inquire}</span>
                  </div>
                )}
                {item.formattedUnitPrice && item.formattedUnitPrice === 'Login' && !authCtx.isLoggedIn && (
                  <div className={styles.btnUnderline}>
                    <p>
                      <a href={loginUrl} className={styles.btnlinkU}>{label_login}</a>
                    </p>
                </div>
                )}
              </div>
            )}
          </div>
        );
      })}
      {!quoteDetail && (
        <div className={styles.footerLink}>
          <button onClick={onViewDetails}
            className={`${styles.linkBtn} ${isFirstWhite ? styles.rowWhite : styles.rowGray}`}>
            {viewDetails} <ChevronRight size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default QuoteExpanded;
